import type { currentSurveySliceState } from "@survey-types/survey.core.types";
import type { MediaFile, MediaFiles } from "@survey-types/survey.media.types";

export const mediaReducers = {
  // Define your media reducers here
  setMedia: (
    state: currentSurveySliceState,
    action: { payload: MediaFiles },
  ) => {
    state.mediaFiles = action.payload;
  },
  setPropertyMedia: (
    state: currentSurveySliceState,
    action: { payload: MediaFiles },
  ) => {
    if (!state.mediaFiles) {
      state.mediaFiles = {};
    }
    // Merge the propertyMedia with existing mediaFiles without overwriting
    Object.entries(action.payload).forEach(([propertyId, mediaData]) => {
      if (!state.mediaFiles![propertyId]) {
        state.mediaFiles![propertyId] = {
          images: [],
          floorPlans: [],
          fliers: [],
        };
      }
      // Update each media type for this property
      if (mediaData.images?.length) {
        state.mediaFiles![propertyId].images = mediaData.images;
      }
      if (mediaData.floorPlans?.length) {
        state.mediaFiles![propertyId].floorPlans = mediaData.floorPlans;
      }
      if (mediaData.fliers?.length) {
        state.mediaFiles![propertyId].fliers = mediaData.fliers;
      }
    });
  },
  updateMedia: (
    state: currentSurveySliceState,
    action: {
      payload: {
        propertyId: string;
        mediaType: "images" | "floorPlans" | "fliers";
        media: MediaFile[];
      };
    },
  ) => {
    const { propertyId, mediaType, media } = action.payload;
    if (!state.mediaFiles) {
      state.mediaFiles = {};
    }
    if (!state.mediaFiles[propertyId]) {
      state.mediaFiles[propertyId] = { images: [], floorPlans: [], fliers: [] };
    }
    state.mediaFiles[propertyId][mediaType] = (
      state.mediaFiles[propertyId][mediaType] || []
    ).concat(media);
  },
  reorderMedia: (
    state: currentSurveySliceState,
    action: {
      payload: {
        propertyId: string;
        mediaType: "images" | "floorPlans" | "fliers";
        media: MediaFile[];
      };
    },
  ) => {
    const { propertyId, mediaType, media } = action.payload;
    if (
      state.mediaFiles &&
      state.mediaFiles[propertyId] &&
      state.mediaFiles[propertyId][mediaType]
    ) {
      state.mediaFiles[propertyId][mediaType] = media;
    }
  },
  removeMedia: (
    state: currentSurveySliceState,
    action: {
      payload: {
        propertyId: string;
        mediaType: "images" | "floorPlans" | "fliers";
        mediaId: string;
      };
    },
  ) => {
    const { propertyId, mediaType, mediaId } = action.payload;
    if (
      state.mediaFiles &&
      state.mediaFiles[propertyId] &&
      state.mediaFiles[propertyId][mediaType]
    ) {
      state.mediaFiles[propertyId][mediaType] = state.mediaFiles[propertyId][
        mediaType
      ].filter((file) => !file.mediaId.includes(mediaId));
    }
  },
  moveMedia: (
    state: currentSurveySliceState,
    action: {
      payload: {
        propertyId: string;
        fromType: "images" | "floorPlans" | "fliers";
        toType: "images" | "floorPlans" | "fliers";
        mediaId: string;
      };
    },
  ) => {
    const { propertyId, fromType, toType, mediaId } = action.payload;
    if (!state.mediaFiles?.[propertyId]) return;
    const sourceArray = state.mediaFiles[propertyId][fromType];
    const fileIndex = sourceArray.findIndex((f) => f.mediaId === mediaId);
    if (fileIndex === -1) return;
    const file = sourceArray[fileIndex];
    state.mediaFiles[propertyId][fromType] = sourceArray.filter(
      (f) => f.mediaId !== mediaId,
    );
    state.mediaFiles[propertyId][toType] = [
      ...state.mediaFiles[propertyId][toType],
      { ...file, mediaType: toType.toUpperCase() },
    ];
  },
};
